module.exports = __webpack_public_path__ + "img/ic-pt-plus.f385f168.svg";